var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvGadget(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40.9 34.7",
    style: {
      enableBackground: "new 0 0 40.9 34.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2412",
    transform: "translate(0 -33.592)",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2411",
    transform: "translate(0 33.592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2410",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2323",
    className: "st1",
    d: "M40.9,32.5l-2.5-10.2c0-0.2-0.1-0.3-0.2-0.4c0.1-0.4,0.2-0.9,0.2-1.3V3.8 c0-2.1-1.7-3.8-3.8-3.8H6.4C4.3,0,2.6,1.7,2.6,3.8v16.8c0,0.4,0.1,0.9,0.2,1.3c-0.1,0.1-0.1,0.3-0.2,0.4L0.1,32.6 c-0.2,0.9,0.3,1.8,1.2,2.1c0.1,0,0.3,0.1,0.4,0.1h37.5c0.9,0,1.7-0.8,1.7-1.7C40.9,32.8,40.9,32.6,40.9,32.5z M24.8,32h-8.7 c-0.2,0-0.3-0.2-0.3-0.3c0,0,0,0,0-0.1l0.7-3.7c0-0.2,0.2-0.3,0.3-0.3h7.3c0.2,0,0.3,0.1,0.3,0.3l0.7,3.7 C25.2,31.8,25.1,32,24.8,32C24.9,32,24.8,32,24.8,32L24.8,32z M35,20.6c0,0.2-0.1,0.4-0.3,0.4H6.2c-0.2-0.1-0.3-0.2-0.3-0.4V3.8 c0-0.3,0.2-0.5,0.5-0.5c0,0,0,0,0,0h28.2c0.3,0,0.5,0.2,0.5,0.5v0V20.6z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvGadget);
export default __webpack_public_path__ + "static/media/av-gadget.91a4fd757452c05d84a449235ffb59be.svg";
export { ForwardRef as ReactComponent };